
// import Vue from './main';
import VueLazyLoad from 'vue-lazyload';
// import { InputNumber } from 'element-ui'
import wish from './lib/directives/wish'
import { cartMixin } from './lib/mixins/cart'
import cart from './lib/dialog/cart-dialog'
import anystorlingGoods from "./components/anystorlingGoods";


import swiper from './lib/mixins/swiper'
import { store } from './header'
Vue.use(VueLazyLoad, {
  preLoad: 1,
  attempt: 1,
});

new Vue({
  el: '#app',
  mixins: [cartMixin, swiper],
  directives: { wish },
  data: {
    a: false,
    swpierCount: 0
  },
  mounted() {
    if (store.state.isLogin) {
      this.visitRecord()
    }
    var CountEvent = window.JAnalyticsInterface.Event.CountEvent;
    var cEvent = new CountEvent("jg_app_active");
    window.JAnalyticsInterface.onEvent(cEvent);
    // 默认只加载第一页轮播图
    this.setSrc(this.crouselDOM[0].firstElementChild.firstElementChild)
    // var divElement = document.getElementById("slideshowCount");
    // this.swpierCount = divElement.getAttribute("data-custom-value");
    // console.log(this.swpierCount,divElement);
    //   document.getElementsByClassName('el-carousel__arrow--left')[0].classList.add('noneElcarouse')
    //   document.getElementsByClassName('el-carousel__arrow--right')[0].classList.add('noneElcarouse')
    //   console.log(document.getElementsByClassName('el-carousel__arrow--left')[0],'divElement.getElementsByTagNam');
  },
  methods: {
    setSrc(img, count) {
      if (!img.hasAttribute('lazyImage')) return
      img.src = img.getAttribute('lazyImage')
      img.removeAttribute('lazyImage')
      img.style.opacity = 1
    },
    // 打开登录模块, 未登录的情况下点击收藏会启用
    openLogin() {
      store.commit('OPEN_LOGIN', document.querySelector('#sidebar'))
    },
    // 登记用户访问
    visitRecord() {
      this.$json.post('user_visit', {
        origin: 1
      }).catch(err => {
        console.log(err.msg);
      })
    },
    showCart(goodsDetails) {
      cart(goodsDetails)
    },
    golbt(id) {
      var CountEvent = window.JAnalyticsInterface.Event.CountEvent;
      var cEvent = new CountEvent("jg_app_active");
      window.JAnalyticsInterface.onEvent(cEvent);
    },
    goMore(id) {
      const route = window.location
      const localLang = localStorage.getItem('localLang')
      let url
      url = `${route.origin}${'/' + localLang}/search/?keyword=&activity_id=${id}`
      route.href = url
    },
    goUrl(id) {
      // 决定用location
      const route = window.location
      const localLang = localStorage.getItem('localLang')
      let url
      url = `${route.origin}${localLang != 'en' ? '/' + localLang : ''}/product/${id}`
      route.href = url
    },
    // 收藏/取消收藏
    wish(id) {
      const promise = this.favorite[id] ? this.$json.delete(`favorite/product/${id}`) : this.$json.post('favorite', {
        type: 1,
        content: id
      })
      promise.then(res => {
        this.$message.success(res.msg)
        if (this.favorite[id]) {
          store.commit('UPDATA_FAVORITE_LIST', {
            fav_type: 1,
            fav_content: id
          })
        } else {
          store.commit('UPDATA_FAVORITE_LIST', {
            symbol: 1,
            id: res.data,
            fav_type: 1,
            fav_content: id
          })
        }
      })
    },
  },
  computed: {
    // 转换收藏列表
    favorite() {
      return store.state.favoriteList[1] ? store.state.favoriteList[1].reduce((pre, cur) => {
        pre[cur.fav_content] = cur
        return pre
      }, {}) : {}
    },
    crouselDOM() {
      return document.querySelector('#homeCrousel').querySelector('.el-carousel__container').querySelectorAll('.el-carousel__item')
    }
  },
  components: {
    anystorlingGoods
  },
});


// WEBPACK FOOTER //
// ./resources/js/home.js